<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <button v-show="pageShowData" v-on:click="onPrintButtonClick" type="button" class="btn btn-warning" style="float:right">
        Print
      </button>

      <h3 id="title2">{{ 'TERMINATION PASSCARD RETURN APPLICATION ' + (pageApplicationNum || '') }}</h3>

      <hr>

      <div 
        v-show="pageShowData"
        class="row"
        style="padding-left: 30px; padding-right: 30px">

        <AppForm
          ref="pageForm" 
          v-bind:formParameter="PARAM"
          v-bind:permission="permission"
          class="col">

        </AppForm>

        <div
          v-show="pageShowExtra"
          class="col-auto"
          slot="jt-form-slot-Application ID"
          style="border-style: solid; width: 400px; height: 250px; text-align: center; margin: auto; padding: 70px 0;">
          Place Card Here
          <br>
          (Passcard No: {{ pageApplicationPasscardNo }})
        </div>

      </div>

      <hr>

      <div 
        v-show="pageShowExtra"
        style="padding-left: 30px; padding-right: 30px">

        <img v-bind:src="imageHeader" style="width: 100%"/>

        <br>
        <br>
        <h3 style="text-align: center">PASSCARD RETURN ACKNOWLEDGEMENT</h3>
        <br>

        <div>
          This is to confirm that parking access card no <b>{{pageApplicationPasscardNo}}</b> belong to 
          <b>{{pageApplicationCarpark}}</b>
          <br>
          <br>
          <label class="form-control-static">Has Been Received By:</label>
          <table>
            <tr>
              <td><label class="form-control-static">Staff Name:</label></td>
              <td><label class="form-control-static"><b>{{pageApplicationStaffName}}</b></label></td>
            </tr>
            <tr>
              <td><label class="form-control-static">Staff No: </label></td>
              <td><label class="form-control-static"><b>{{pageApplicationStaffNo}}</b></label></td>
            </tr>
            <tr>
              <td><label class="form-control-static">Submission Date: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></td>
              <td><label class="form-control-static"><b>{{pageApplicationSubmissionDate}}</b></label></td>
            </tr>
            <tr>
              <td><label class="form-control-static">Form ID: </label></td>
              <td><label class="form-control-static"><b>{{pageApplicationNum}}</b></label></td>
            </tr>
          </table>
        </div>

        <br>
        <TemplateButton 
          v-show="pageShowAction && pageAction"
          type="button"
          class="btn btn-primary"
          v-on:click="onActionButtonClick">
          {{pageAction}}
        </TemplateButton>

      </div>

      <!-- <TemplateButton 
        v-show="pageShowPaid"
        type="button"
        class="btn btn-danger"
        v-on:click="onPaidButtonClick">
        Paid
      </TemplateButton> -->

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: 'Application ID',
  },
  {
    key: 'Car Park Name',
  },
  {
    key: 'Car Park Product Name',
  },
  {
    key: 'Parking License',
  },
  {
    key: 'Account Holder Name',
  },
  {
    key: 'Submission Date',
  },
  {
    key: 'Parker Name',
  },
  {
    key: 'Phone No.',
  },
  {
    key: 'Passcard Type',
  },
  {
    key: 'Passcard No.',
  },
  {
    key: 'Passcard Condition',
  },
  {
    form_section: 'STAFF INPUT INFORMATION',
  },
  {
    key: 'Staff Name',
  },
  {
    key: 'Staff No.',
  },
];
PARAM.forEach(k => {
  k['form_html'] = k['form_html'] || function(formInputParameter, formData) {
    return `<div class="row">
      <label class="control-label text-left col-md-3">${formInputParameter.key} :</label>
      <div class="col-md-9"><p class="form-control-static"><b>${formData[formInputParameter.key] || ' '}</b></p></div>
      </div>`;
      // the space is needed to pass DOM empty check
  }
});
const PARAM_MAP = helper.transformParamToMap(PARAM);


export default {
  name: "PagePasscardTerminationForm",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'Termination Return', url: '/passcardTermination' },
        { name: 'Application' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageTermination: null,
      pageLease: null,
      pageSeason: null,
      pageFees: {},
      pageParker: null,

      pageApplicationNum: '',
      pageApplicationPasscardNo: '',
      pageApplicationCarpark: '',
      pageApplicationStaffName: '',
      pageApplicationStaffNo: '',
      pageApplicationSubmissionDate: '',
      pageShowData: false,
      pageShowExtra: false,
      pageAction: null,
      pageShowAction: true,
      pageShowPaid: false,

      imageHeader: '',
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/passcardTermination');
    });

    this.loadApplication();
  },
  methods: {
    loadApplication() {
      this.pageShowAction = this.$route.query.action;
      if(helper.hasEditPermission(this.permission)) {
        this.pageShowAction = this.pageShowAction;
      } else {
        this.pageShowAction = false;
      }
      
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {

        let feedbackItem = 'termination passcard return application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=passcardTerminationReturn',
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.pageLease = response.data;
            this.pageApplication = response.data[0];
            this.loadStaff();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
      }
    },
    loadStaff() {
      let feedbackItem = 'staff data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageStaff = response.data;
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.loadCarparkFinance();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarparkFinance() {
      let feedbackItem = 'car park detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageApplication['carparkID'] + '/finance/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageFinance = response.data[0];
            this.imageHeader = this.pageFinance.logoHeader1;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadZone();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No passcard available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageApplication['carparkID'] + '/license/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });

          if(response.data && response.data.length > 0) {
            this.loadPasscard();
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageApplication['carparkID'] + '/passcard/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      this.loadLeaseData();
    },
    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.checkSeasonFees()) {
        return;
      }

      let temp = {};
      this.pageApplicationNum = temp['Application ID'] = helper.plFormPLPRNum(this.pageApplication['applicationID'], this.pageApplication['carparkID']);
      let carpark  = this.pageCarpark.find(k => helper.compareID(k.id, this.pageApplication['carparkID'])) || {};
      this.pageApplicationCarpark = temp['Car Park Name'] = carpark['name'];
      let season  = this.pageSeason.find(k => helper.compareID(k.id, this.pageApplication['seasonID'])) || {};
      temp['Car Park Product Name'] = season['name'];
      let license = this.pageLicense.find(k => helper.compareID(k.id, this.pageApplication['licenseID'])) || {};
      temp['Parking License'] = helper.plFormPLNum(license['licenseOperatorNum'], license['carparkID']);
      let customer = this.pageCustomer.find(k => helper.compareID(k.id, this.pageApplication['customerID'])) || {};
      temp['Account Holder Name'] = customer['name'];
      let parker = this.pageParker.find(k => helper.compareID(k.id, this.pageApplication['parkerID'])) || {};
      temp['Parker Name'] = parker['name'];
      temp['Phone No.'] = parker['mobile'];
      let passcard = this.pagePasscard.find(k => helper.compareID(k.id, this.pageApplication['passcardID'])) || {};
      let passtype = this.pagePasstype.find(k => helper.compareID(k.id, passcard['passtypeID'])) || {};
      temp['Passcard Type'] = passtype['name'];
      this.pageApplicationPasscardNo = temp['Passcard No.'] = passcard['sku'];
      temp['Passcard Condition'] = this.pageApplication['data2'];
      this.pageApplicationSubmissionDate = temp['Submission Date'] = helper.formatDate(this.pageApplication['createDate']);
      let staff = this.pageStaff.find(k => helper.compareID(k.id, this.pageApplication['data4'])) || {};
      this.pageApplicationStaffName = temp['Staff Name'] = staff['name'];
      this.pageApplicationStaffNo = temp['Staff No.'] = staff['personnelCode'];
      temp['Staff Remark'] = this.pageApplication['data5'];
      
      this.pageShowExtra = true;
      if(this.pageApplication['status1'] === 'Approved') {
        this.pageAction = 'Mark as Inventory In Stock';
      }

      this.$refs['pageForm'].setForm(false, temp);
      this.pageShowData = true;
    },
    loadSeason() {
      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.pageApplication['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(this.pageFees[seasonID] = response.data) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + this.pageApplication['customerID'] + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    checkSeasonFees() {
      for(let leaseData of this.pageLease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },
    
    onPrintButtonClick() {
      window.print();
    },
    onActionButtonClick() {
      let feedbackItem = 'termination passcard return appplication status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardTerminationReturn/markInStock',
          querystring.stringify({leases: JSON.stringify([].concat(this.pageApplication))}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(this.$route.query.action) {
            helper.redirect({ path: helper.WEB_URL + '/passcardReturnTermination', query: { carparkID: this.pageApplication['carparkID'], licenseID: this.pageApplication['licenseID'] }});
          } else {
            helper.redirect({ path: helper.WEB_URL + '/passcardTermination', query: { carparkID: this.pageApplication['carparkID'], licenseID: this.pageApplication['licenseID'] }});
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    onPaidButtonClick() {
      let feedbackItem = 'passcard lost/damage/faulty appplication status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePasscardLostDamageFaulty/paid',
          querystring.stringify({leases: JSON.stringify([].concat(this.pageApplication))}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          helper.redirect({ path: helper.WEB_URL + '/passcardLostDamageFaulty', query: { carparkID: this.pageApplication['carparkID'], licenseID: this.pageApplication['licenseID'] }});
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscardTerminationForm.vue